<template>
    <div class="page-root">
        <div class="nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item
                    :to="{name: 'INDEX'}"
                    @click.native="handleBreadcrumb('index')"
                >首页</el-breadcrumb-item>
                <el-breadcrumb-item
                    :to="{
                        name: 'CAR_TRAIN',
                        query: {
                            seriesName: query.seriesName
                        },
                        params: {
                            serid: query.seriesId
                        }
                    }"
                    @click.native="handleBreadcrumb('carTrain')"
                >{{ query.seriesName }}</el-breadcrumb-item>
                <el-breadcrumb-item>口碑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <h2 class="name">
            <div class="brand-logo">
                <b>{{ query.seriesName }}</b>
            </div>
            <div class="select-car-module">
                <el-select
                    v-model="currModel"
                    value-key="ModelId"
                    @change="handleSelectModel"
                >
                    <div
                        v-for="item in modelList"
                        :key="item.Type"
                    >
                        <div
                            v-if="item.Type !== 'allCar'"
                            class="option-type"
                        >{{ item.Type }}</div>
                        <el-option
                            v-for="model in item.ModelArray"
                            :key="model.ModelId"
                            :label="model.ModelName"
                            :value="model"
                        />
                    </div>
                </el-select>
                <p class="select-car-display">
                    {{ currModel.ModelName }}
                </p>
            </div>
        </h2>
        <div class="car-intro">
            <div class="big-img">
                <img
                    v-real-src="praiseInfo.image"
                    src="@/assets/images/bitmap-small.png"
                >
            </div>
            <div class="intro-marks">
                <div class="marks-info">
                    <p class="marks-num">{{ praiseInfo.average }}</p>
                    <template v-if="praiseInfo.average && praiseInfo.average !== '暂无评分'">
                        <c-stars :full-stars="praiseInfo.average"/>
                    </template>
                    <p class="marks-all-num">{{ praiseInfo.num }}</p>
                </div>
                <ul class="marks-classify">
                    <li
                        v-for="(item, index) in (praiseInfo.param || [])"
                        :key="index"
                        class="classify-item"
                    >
                        <p class="item-name">{{ item.class }}</p>
                        <p class="item-marks">{{ item.praise_average }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div
            ref="content"
            class="content"
        >
            <c-tabs
                ref="tabs"
                :tabs="classList"
                :tags="tagList.allTags"
                :need-fixed="true"
                first-tab="综合"
                :first-tag="'全部(' + tagList.num + ')'"
                @change="handleTabChange"
            />
            <div class="comment-content">
                <template v-for="(item, index) in praiseList">
                    <div
                        :key="index + '__' + item.model_id"
                        class="comment-item"
                    >
                        <div class="user">
                            <div class="user-info">
                                <div class="user-avatar">
                                    <img
                                        v-real-src="item.avatar"
                                        src="@/common/images/user-comment/avatar-default.png"
                                    />
                                </div>
                                <div class="user-name">{{ item.nickname }}</div>
                            </div>
                            <p class="car-price">裸车购买价：{{ item.purchase_price }}</p>
                            <p class="car-buytime">购车时间：{{ item.purchase_date }}</p>
                            <p class="car-buylocation">购车城市：{{ item.purchase_city_name }}</p>
                        </div>
                        <div class="comment">
                            <p class="car-name">{{ item.model_name }}</p>
                            <div class="car-status">
                                <p class="car-oil">
                                    <img src="@/common/images/user-comment/oil.svg">
                                    <span v-if="item.owner_battery_consumption">电耗：{{ item.owner_battery_consumption }}</span>
                                    <span v-else>油耗：{{ item.owner_fuel_consumption || '暂无数据' }}</span>
                                </p>
                                <p class="car-mile">
                                    <img src="@/common/images/user-comment/mile.svg">
                                    <span>里程：{{ item.mileage }}</span>
                                </p>
                            </div>
                            <div class="">
                                <div
                                    v-if="!spreadIdx.includes(index)"
                                    class="car-comment"
                                >
                                    <template v-if="item.content">
                                        <div
                                            v-for="(comment, idx) in item.content"
                                            :key="idx"
                                            class="car-comment-item"
                                        >
                                            <p class="comment-item-left">{{ comment.name }}</p>
                                            <p class="comment-item-right c-line-clamp2">{{ comment.value }}</p>
                                        </div>
                                    </template>
                                </div>
                                <div
                                    v-if="spreadIdx.includes(index)"
                                    class="car-comment-more"
                                >
                                    <div
                                        v-if="!item.detailComment"
                                        class="loading-loading"
                                    >
                                        <i class="el-icon-loading"/>
                                        加载中
                                    </div>
                                    <template v-if="item.detailComment">
                                        <div
                                            v-for="(com, i) in item.detailComment"
                                            :key="i"
                                            class="car-comment-item"
                                        >
                                            <p class="comment-item-left">{{ com.name }}</p>
                                            <p
                                                class="comment-item-right"
                                                :class="{'c-line-clamp2': !spreadIdx.includes(index)}"
                                                v-html="$xss(com.value)"
                                            ></p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div
                                class="watch-more"
                                @click="handleSpreadComment(item, index)"
                            >
                                <template
                                    v-if="!spreadIdx.includes(index)"
                                    class="spread-close"
                                >
                                    <span>展开全文</span>
                                    <img src="@/common/images/user-comment/array-down.svg">
                                </template>
                                <template
                                    v-else
                                    class="spread-open"
                                >
                                    <span>收起</span>
                                    <img src="@/common/images/user-comment/array-up.svg">
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <c-pull-up-loading
            v-if="loading || commentComplete"
            :loading="loading"
            :complete="commentComplete"
        />
        <c-scroll-top/>
    </div>
</template>

<script>
/**
 * @file 口碑列表页
 * @author guozhihao02
 */
import request from 'http/request';
import URLS from 'http/URLS';
import mixinLog from '@/mixin/log.js';
import {sendLog} from 'js/log';
import {on, off} from 'js/Utils';
import {get, throttle} from 'lodash';
import Stars from '../../components/stars';
import Tabs from '../../components/tabs';
import pullUpLoading from 'components/pull-up-loading';
import scrollTop from 'components/scroll-top';
import xss from 'xss';


export default {
    mixins: [mixinLog],
    components: {
        'c-stars': Stars,
        'c-tabs': Tabs,
        'c-pull-up-loading': pullUpLoading,
        'c-scroll-top': scrollTop
    },
    props: {
        serid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            carModelInfo: {},
            currModel: {},
            query: {},
            praiseInfo: {},
            tagList: {},
            praiseList: [],
            classList: [],
            spreadIdx: [],
            mainTab: {}, // 一级tab
            subTab: {}, // 二级tab
            modelList: {},
            loading: false,
            commentComplete: false,
            pn: 0,
            firstRender: true
        };
    },
    created() {
        this.query = {
            ...this.$route.query
        };
        if (!this.query.seriesId && this.serid) {
            this.query.seriesId = this.serid;
        }
        this.$nextTick(() => {
            this.getData();
        });
    },
    activated() {
        this.stopRequest = false;
        on(window, 'scroll', this.infiniteLoad);
    },
    deactivated() {
        this.stopRequest = true;
        off(window, 'scroll', this.infiniteLoad);
    },
    beforeDestroy() {
        off(window, 'scroll', this.infiniteLoad);
    },
    methods: {
        handleSelectModel(value) {
            /* eslint-disable camelcase */
            this.query.modelId = value.ModelId;
            /* eslint-enable camelcase */
            this.pn = 0;
            this.spreadIdx = [];
            this.sendLog('choose_model');
            this.$nextTick(() => {
                this.getData();
            });
        },
        needsGetNewData() {
            let scrollY = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop;
            let scrollHeight = document.documentElement.scrollHeight
                || document.body.scrollHeight;
            let screenHeight = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;
            if (scrollHeight - scrollY < screenHeight + 100) {
                this.scrollTop = scrollY;
                this.getData(true, true);
            }
        },
        infiniteLoad: throttle(function () {
            if (this.commentComplete || this.loading) {
                return;
            }
            let scrollY = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop;
            if (this.scrollTop !== scrollY) {
                this.needsGetNewData();
            }
        }, 100, {leading: false}),
        getData(flushTag, pullup) {
            const {mainTab, subTab} = this;
            const {seriesId} = this.query;
            const {ModelId} = this.currModel;
            if (!seriesId || this.loading) {
                return;
            }
            this.loading = true;
            /* eslint-disable camelcase */
            request(URLS.GETPRAISELIST, {
                series_id: seriesId,
                class: mainTab.name || '',
                tag_list: subTab.tag || '',
                model_id: ModelId === 'all' ? '' : ModelId,
                pn: this.pn,
                rn: 10
            })
                .then(res => {
                    const {praise_info, tag_list, praise_list, class_list = [], modelIndex} = res.Result;
                    if (!this.modelList.length) {
                        const modelList = get(modelIndex, '[0].HorseModelArray', []);
                        // 全部车型
                        modelList.unshift({
                            Type: 'allCar',
                            ModelArray: [{
                                ModelName: '全部车型',
                                ModelId: 'all'
                            }]
                        });
                        this.currModel = modelList[0].ModelArray[0];
                        this.modelList = modelList;
                    }
                    if (!this.classList.length) {
                        this.classList = class_list;
                    }
                    // 是否刷新tag
                    if (!flushTag) {
                        tag_list.allTags = [
                            ...(tag_list.advantage || []).map(v => {
                                v.commentType = 'good';
                                return v;
                            }),
                            ...(tag_list.disadvantage || []).map(v => {
                                v.commentType = 'bad';
                                return v;
                            })
                        ];
                        this.tagList = tag_list;
                    }
                    this.praiseInfo = praise_info;
                    if (pullup) {
                        this.praiseList.push(...praise_list);
                    }
                    else {
                        this.praiseList = praise_list;
                        this.$nextTick(() => {
                            this.scrollToCommentTop();
                        });
                    }
                    if (praise_list.length < 10) {
                        this.commentComplete = true;
                    }
                    this.$nextTick(() => {
                        this.needsGetNewData();
                        this.loading = false;
                        this.pn++;
                        // 判断是否需要滚动到具体评论
                        if (this.firstRender && this.query.hasOwnProperty('index')) {
                            this.scrollToCommentIdx(this.query.index);
                            this.firstRender = false;
                        }
                    });
                })
                .catch(err => {
                    // console.log(err);
                });
            /* eslint-enable camelcase */
        },
        handleSpreadComment(item, index) {
            // 如果展开数组中已经有了，则说明需要折叠
            if (this.spreadIdx.includes(index)) {
                this.spreadIdx = this.spreadIdx.filter(v => v !== index);
                this.sendLog('spread', {
                    pos: index,
                    type: 'spread'
                });
            }
            else {
                this.getPraiseInfo(item, index);
                this.sendLog('spread', {
                    pos: index,
                    type: 'fold'
                });
            }
        },
        getPraiseInfo(item, index) {
            this.spreadIdx.push(index);
            // 如果已经存在评论了，不用继续请求
            if (item.detailComment && item.detailComment.length) {
                return;
            }
            /* eslint-disable camelcase */
            request(URLS.GETPRAISEINFO, {
                loc: item.loc,
                model_id: item.model_id
            })
                .then(res => {
                    this.$set(item, 'detailComment', res.Result.praise_list || []);
                })
                .catch(err => {});
            /* eslint-enable camelcase */
        },
        handleTabChange({type, value, index}) {
            this.pn = 0;
            this.spreadIdx = [];
            // 一级tab变化
            if (type === 'main') {
                this.mainTab = value;
                this.subTab = {};
                this.getData();
                this.sendLog('tab', {
                    pos: index
                });
            }
            else if (type === 'sub') {
                this.subTab = value;
                this.getData(true);
                this.sendLog('tag', {
                    pos: index
                });
            }
        },
        $xss(html) {
            const options = {
                // 默认白名单参考 xss.whiteList
                whiteList: {
                    span: ['style']
                }
            };

            // 对 html 进行高亮处理
            if (this.subTab && this.subTab.tag_org) {
                const tag = this.subTab.tag_org;
                html = html.replace(tag, `<span style="color: #FF6D46;">${tag}</span>`);
            }

            return xss(html, options);
        },
        scrollToCommentTop() {
            let offsetTop = this.$refs.content.offsetTop;
            let scrollY = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop;
            if (offsetTop - scrollY < 0) {
                window.scrollTo(0, this.$refs.content.offsetTop);
            }
        },
        scrollToCommentIdx(index) {
            const ele = document.querySelectorAll('.comment-item')[index];
            if (ele) {
                let offsetTop = ele.offsetTop;
                let tabHeight = get(this.$refs.tabs, '$refs.tabContent.offsetHeight', undefined);
                // 如果不能正确获取到tab的高度，那么不需要锚点定位，因为可能会滚到一个错误的位置
                if (tabHeight !== undefined) {
                    this.getPraiseInfo(this.praiseList[+index], +index);
                    setTimeout(() => {
                        window.scrollTo(0, offsetTop - tabHeight);
                    }, 100);
                }
            }
        },
        handleBreadcrumb(page) {
            this.sendLog('navigateTo', {
                page
            });
        },
        sendLog(key, params) {
            sendLog(`userComment_${key}`, {
                seriesId: this.query.seriesId,
                seriesName: this.query.seriesName,
                ...(params || {})
            });
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.page-root {
    margin-top: 30px;
    padding-bottom: 80px;
}
.name {
    display: flex;
    font-size: 36px;
    width: 100%;
    letter-spacing: 0;
    margin-top: 29px;
    height: 50px;
    align-items: flex-end;
    .brand-logo {
        height: 50px;
    }
    a {
        display: inline-block;
        color: #333333;
        align-items: center;
        overflow: hidden;
    }
    b {
        float: left;
        line-height: 50px;
    }
}
.select-car-module {
    position: relative;
    margin-left: 12px;
    .el-select {
        position: absolute;
        width: 100%;
        height: 40px;
        // 把自带框给隐藏
        /deep/ .el-input__inner {
            opacity: 0;
            border: none;
            font-size: 20px;
            color: #FFFFFF;
        }
        /deep/ .el-input__icon.el-icon-arrow-up {
            color: #333333;
        }
    }
    .select-car-display {
        font-size: 20px;
        line-height: 40px;
        min-width: 100px;
        height: 40px;
        padding: 0 35px 0 0;
        color: #333333;
    }
}
.option-type {
    position: sticky;
    top: 0;
    height: 28px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 28px;
    background-color: rgba(241, 241, 241);
    z-index: 1;
}
.car-intro {
    display: flex;
    margin-top: 32px;
    .big-img {
        width: 396px;
        height: 264px;
        margin-right: 50px;
        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .intro-marks {
        flex: 1;
    }
    .marks-info {
        display: flex;
        align-items: center;
        .marks-num {
            margin-right: 10px;
            font-family: PingFangSC-Semibold;
            font-size: 42px;
            letter-spacing: .66px;
            color: #333333;
        }
        .marks-all-num {
            margin-left: 10px;
            font-size: 14px;
            color: #2A2A2A;
            span {
                color: #333333;
            }
        }
    }
    .marks-classify {
        display: flex;
        flex-wrap: wrap;
        width: 500px;
        margin-top: 30px;
        font-size: 14px;
        line-height: 14px;
        color: #333333;
        .classify-item {
            width: 50%;
            display: flex;
            margin-bottom: 18px;
            .item-name {
                width: 100px;
            }
            .item-marks {
                font-weight: 500;
            }
        }
    }
}
.content {
    margin-top: 40px;
    .comment-content {
        margin-top: 6px;
    }
    .comment-item {
        display: flex;
        padding: 38px 0 20px;
        border-bottom: 1px solid #EEEEEE;
        overflow: hidden;
    }
    .user {
        width: 237px;
        .user-info {
            display: flex;
            align-items: center;
            margin-bottom: 11px;
        }
        .user-avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            overflow: hidden;
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
        .user-name {
            font-size: 16px;
            line-height: 16px;
            margin-left: 8px;
            color: #333333;
        }
        .car-price,
        .car-buytime,
        .car-buylocation {
            font-size: 14px;
            color: #666666;
            line-height: 22px;
        }
    }
    .comment {
        flex: 1;
        .car-name {
            font-size: 22px;
            line-height: 22px;
            color: #333333;
        }
        .car-status {
            display: flex;
            margin-top: 8px;
            font-size: 14px;
            height: 14px;
            color: #666666;
            > p {
                display: flex;
                align-items: center;
                margin-right: 24px;
            }
            img {
                margin-right: 4px;
            }
        }
        .car-comment {
            flex: 1;
            margin-top: 30px;
        }
        .car-comment-item {
            display: flex;
            overflow: hidden;
            margin-bottom: 7px;
            line-height: 24px;
            font-size: 14px;
            color: #333333;
            .comment-item-left {
                width: 68px;
                font-size: 14px;
                font-weight: 500;
            }
            .comment-item-right {
                flex: 1;
                margin-bottom: 0;
            }
        }
        .car-comment-more {
            margin-top: 30px;
        }
        .watch-more {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100px;
            line-height: 14px;
            margin: 10px auto 0;
            user-select: none;
            color: @themeColor;
            cursor: pointer;
        }
    }
}
.nav {
    margin-top: 30px;
    .el-breadcrumb {
        font-size: 16px;
    }
    /deep/ .el-breadcrumb__item {
        cursor: pointer;
        .el-breadcrumb__inner {
            color: #333;
            &.is-link {
                font-weight: 400;
            }
            &:hover {
                color: #333;
            }
        }
        &[aria-current="page"] .el-breadcrumb__inner {
            color: #333;
            cursor: default!important;
            &:hover {
                color: #333;
            }
        }
    }
    /deep/ .el-breadcrumb__separator {
        margin: 0;
    }
}
.loading-loading {
    display: block;
    width: 100%;
    margin-top: 40px;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #999999;
    i {
        margin-right: 8px;
    }
}
.el-select-dropdown {
    .el-select-dropdown__item.selected {
        color: @themeColor!important;
    }
    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
        background: rgba(0,206,207, .05);
    }
}
</style>